var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',{staticClass:"notification-badge",attrs:{"color":_vm.badge.color,"value":_vm.badge.show,"overlap":"","dot":""}},[_c('v-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"title":"Notificações","icon":"","large":""},on:{"click":_vm.onClickNotifications}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v(" mdi-bell-outline ")])],1)]}}])},[_c('notification-area')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }